import React from 'react';
import { useSelector } from 'react-redux';

export default function WitnessStatusBanner({ currentTab, isExpired = false }) {
  const { baseInfo } = useSelector((state) => state.permit);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const detail = baseInfo.detailMap?.[currentTab];

  if (!detail) return null;

  const isDone = detail.witnessStatus === '입회완료';
  const isIng = detail.witnessStatus === '입회중';
  const isOtherUserWorking =
    detail.updateId && detail.updateId !== userInfo?.decUserId;

  if (isExpired) {
    return (
      <div className="-mx-5 flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-5 py-2.5">
        <span
          className="material-symbols-outlined shrink-0 text-lg text-amber-500"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          schedule
        </span>
        <p className="text-[13px] font-bold text-amber-700">
          작업 종료 후 입력 가능 시간이 지나 입회 확인이 마감되었습니다.
        </p>
      </div>
    );
  }

  if (isDone) {
    return (
      <div className="-mx-5 flex items-center gap-2 border-b border-[#5ABD4F]/20 bg-[#5ABD4F]/5 px-5 py-2.5">
        <span
          className="material-symbols-outlined shrink-0 text-lg text-[#5ABD4F]"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          check_circle
        </span>
        <p className="text-[13px] font-bold text-[#3f4a3b]">
          [{detail.witnessNm || '입회자'}] 님의 입회 확인 및 서명이 완료된
          항목입니다.
        </p>
      </div>
    );
  }

  if (isIng && isOtherUserWorking) {
    return (
      <div className="-mx-5 flex items-center gap-2 border-b border-red-100 bg-red-50 px-5 py-2.5">
        <span
          className="material-symbols-outlined shrink-0 text-lg text-red-500"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          info
        </span>
        <p className="text-[13px] font-bold text-red-600">
          현재 [{detail.updateNm || '다른 사용자'}] 님이 입회 확인 중입니다.
        </p>
      </div>
    );
  }

  return null;
}
